module.exports = __webpack_public_path__ + "static/media/demo_truck.254404af.jpg";